module.exports = __webpack_public_path__ + "img/icon_tips.80df55f4.svg";